import styled from '@emotion/styled';

import { spacingFn } from '@britishcouncil/react-extro-ui';
export const Title = styled.div`
    font-weight: 700;
    color: #000;
    line-height: 1;
    font-size: ${({theme}) => theme.fontSize.desktop.body};
    margin-bottom: 0;
`;

export const Subtitle = styled.div`
    font-weight: 400;
    line-height: 0;
    color: #54565A;
    margin-bottom: 0;
    font-size: ${({theme}) => theme.fontSize.desktop.small};
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    line-height: 0;

    h6 {
        margin-bottom: 0;
        line-height: 0;
    }

    > :last-child {
        text-align: end;
    }
`;

export const List = styled.div`
  font-size: ${({ theme }) => theme.fontSize.mobile.body};
`;

export const Item = styled.div`
    display: flex;
    margin-bottom: ${spacingFn(0.75)};

    &:last-of-type {
        margin-bottom: 0;
    }

    > :last-child {
        text-align: end;
    }
`;

export const ItemLabel = styled.div`
    color: #000;
    font-size: ${({theme}) => theme.fontSize.desktop.small};
`;

export const ItemAmount = styled.div`
    margin-left: auto;
    font-size: ${({theme}) => theme.fontSize.desktop.small};
    color: #000;
    font-weight: 700;
    min-width: fit-content;
    padding-left: ${({theme}) => theme.spacing.sm};
`;

export const Divider = styled.hr`
    border-top: 1px dashed #003B4A;
    margin: 2px;
`;

export const Summary = styled.div`
    margin-top: 15px;
    padding: 0 5px;
` 
